import React from 'react';

function Notification() {

    // const [notiEmpty, setNotiEmpty] = useState(false)
    const notiEmpty =true
    return (
       <div className="notificationStyle">
           <div className="notificationBox">
               <h5 className="titleNoti">Thông Báo</h5>
               {
                    !notiEmpty ?(
                        <div className="notificationContent">
                            <ul>
                                <li>Thông báo 1</li>
                                <li>Thông báo 1</li>
                                <li>Thông báo 1</li>
                                <li>Thông báo 1</li>
                                <li>Thông báo 1</li>
                            </ul>
                        </div>
                    ):
                    <div className="notificationEmpty">
                            <img className="img-fluid" src="/images/ic_newsletter.png" alt="" />
                            <h5>Thông báo trống</h5>
                            <p>Thông báo của bạn sẽ được hiển thị ở đây</p>
                    </div>
               }
               

           </div>
       </div>
    );
}
export default Notification;